import {Dispatch, ReactElement, SetStateAction} from 'react';
import Image from 'next/legacy/image';
import { Slide as SlideType } from 'types';
import { Switcher } from '../Switcher';

import cx from 'classnames';
import styles from './Slide.module.scss';

export type SlideProps = {
  image: string;
  title: string;
  description: string | ReactElement;
  active: number;
  previousChosen: number;
  setActive: Dispatch<SetStateAction<number>>;
  setPreviousChosen: Dispatch<SetStateAction<number>>;
  index: number;
  slides: SlideType[];
};

export const Slide = ({
  image = '/',
  slides,
  active,
  setActive,
  title,
  description,
  index,
  previousChosen,
  setPreviousChosen,
}: SlideProps) => {
  return (
    <div
      className={cx(styles.container, {
        [styles.active]: active == index,
        [styles.previous]: active > index,
        [styles.next]: active < index,
        [styles.hidden]: ((index != active) && (index != previousChosen)),
      })}
    >
      <div className={styles.content}>
        <h2>{title}</h2>
        <p>{description}</p>
        <Switcher
          active={active}
          setActive={setActive}
          slides={slides}
          setPreviousChosen={setPreviousChosen}
        />
      </div>
      <Image
        src={image}
        layout="fill"
        objectFit="cover"
        objectPosition="left top"
        alt={title}
      />
    </div>
  );
};
